import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Header from "../components/Header/Header";
import OuterFooter from "../components/Footer/OuterFooter";

const Blogs = () => {
  const [featuredBlog, setFeaturedBlog] = useState(null);
  const [blogs, setBlogs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredBlogs, setFilteredBlogs] = useState([]);
  const [mobNav, setMobNav] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
   
    const sampleCategories = [
      { id: "all", name: "All Categories" },
      { id: "ai-education", name: "AI in Education" },
      { id: "learning-tech", name: "Learning Technology" },
      { id: "assessment", name: "Assessment" },
      { id: "case-studies", name: "Case Studies" }
    ];


    const sampleBlogs = [
      {
        id: "transforming-cbse-education",
        title: "Chanakya AI: Transforming the Future of CBSE Education",
        excerpt: "Discover how Chanakya AI is revolutionizing homework creation, assessment, and personalized learning in CBSE schools, making education more efficient and impactful.",
        category: "ai-education",
        author: "Garvit Kothari",
        date: "May 28, 2025",
        readTime: "5 min read",
        thumbnail: "cbseOffice.jpeg",
        featured: true,
        tags: ["CBSE", "Education", "Assessment", "Personalized Learning", "Instant Grading"]
      },
       {
        id: "ai-teachers-revolutionize-education",
        title: "How AI Teachers Can Revolutionize Education and Benefit Students",
        excerpt: "Explore how AI-powered teaching assistants and intelligent tutoring systems are transforming education by providing personalized guidance, 24/7 support, and adaptive learning experiences.",
        category: "ai-education",
        author: "Santosh Kumar",
        date: "May 27, 2025",
        readTime: "7 min read",
        thumbnail: "priya.jpeg",
        featured: false,
        tags: ["AI Teachers", "Personalized Learning", "Educational Technology", "Student Support", "Adaptive Learning"]
      },
      {
        id: "simplify-grading-middle-school",
        title: "Middle School Teachers: Simplify Your Grading with Chanakya AI",
        excerpt: "Discover how Chanakya AI can transform grading from an overwhelming task to a quick and efficient process for middle school teachers.",
        category: "assessment",
        author: "Garvit Kothari",
        date: "May 25, 2025",
        readTime: "4 min read",
        thumbnail: "teacher-grading-ai.jpeg",
        featured: false,
        tags: ["Middle School", "Teachers", "Grading", "Time-Saving", "CBSE"]
      },
      // {
      //   id: "takalkar-school-case-study",
      //   title: "Case Study: How Takalkar School Improved Learning Outcomes with Chanakya AI",
      //   excerpt: "Learn how Takalkar School implemented Chanakya AI and saw a 30% improvement in student assessment scores.",
      //   category: "case-studies",
      //   author: "Harris Fazal",
      //   date: "March 10, 2025",
      //   readTime: "7 min read",
      //   thumbnail: "handWriting.png",
      //   featured: false,
      //   tags: ["Case Study", "Success Story", "Implementation"]
      // },
      {
        id: "future-ai-indian-education",
        title: "The Future of AI in Indian Education System",
        excerpt: "An in-depth look at how AI is positioned to transform the Indian education landscape in the coming years.",
        category: "ai-education",
        author: "Atharv",
        date: "May 22, 2025",
        readTime: "6 min read",
        thumbnail: "future-education-ai.jpeg",
        featured: false,
        tags: ["Future Trends", "India", "Education Policy"]
      },
      {
        id: "formative-summative-assessment",
        title: "Understanding Formative vs Summative Assessment in the Digital Age",
        excerpt: "A comprehensive guide to formative and summative assessments and how technology is enhancing both approaches.",
        category: "assessment",
        author: "Maya Desai",
        date: "May 20, 2025",
        readTime: "8 min read",
        thumbnail: "formative-assessment-digital.jpg",
        featured: false,
        tags: ["Assessment", "Digital Learning", "Education"]
      },
     
      // {
      //   id: "ocr-technology-grading",
      //   title: "How Chanakya AI's OCR Technology is Making Grading Easier for Teachers",
      //   excerpt: "Discover how our advanced OCR technology is helping teachers save time and provide more accurate assessments.",
      //   category: "learning-tech",
      //   author: "Ankit Gupta",
      //   date: "Arpil 25, 2025",
      //   readTime: "5 min read",
      //   thumbnail: "chanakyaAi.webp",
      //   featured: false,
      //   tags: ["OCR", "Teachers", "Technology", "Grading"]
      // }
    ];

    setCategories(sampleCategories);
    setBlogs(sampleBlogs);
    setFilteredBlogs(sampleBlogs);
    setFeaturedBlog(sampleBlogs.find(blog => blog.featured));
  }, []);


  useEffect(() => {
    let filtered = blogs;
    
    
    if (selectedCategory !== "all") {
      filtered = filtered.filter(blog => blog.category === selectedCategory);
    }
    

    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(
        blog =>
          blog.title.toLowerCase().includes(query) ||
          blog.excerpt.toLowerCase().includes(query) ||
          blog.author.toLowerCase().includes(query) ||
          blog.tags.some(tag => tag.toLowerCase().includes(query))
      );
    }
    
    setFilteredBlogs(filtered);
  }, [selectedCategory, searchQuery, blogs]);


  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };


  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) return text;
    return text.substr(0, maxLength) + '...';
  };

  return (
    <div className="blog-page-wrapper">
      <Helmet>
        <title>Chanakya AI Blog - Latest Insights on AI in Education</title>
        <meta name="description" content="Explore the latest articles, news, and insights about AI in education, personalized learning, and assessment technologies on the Chanakya AI blog." />
        <meta name="keywords" content="AI in education, educational technology, Chanakya AI, personalized learning, assessment technology, educational blog" />
        <meta property="og:title" content="Chanakya AI Blog - Latest Insights on AI in Education" />
        <meta property="og:description" content="Explore the latest articles, news, and insights about AI in education, personalized learning, and assessment technologies." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://aichanakya.in/blogs" />
        <link rel="canonical" href="https://aichanakya.in/blogs" />
      </Helmet>

      <Header 
        rightBtnText="Start Learning" 
        rightBtnLink="https://calendly.com/atharv-gyem/discovery-call"
        handleDownloadAppButtonClick={() => {}} 
        mobNav={mobNav}
        setMobNav={setMobNav}
      />

      <div className="blog-main-container">
  
        <section className="blog-hero-section">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="section-header text-center">
                  <span className="leading-mark">CHANAKYA AI BLOG</span>
                  <h1 className="section-title">Insights on AI in Education</h1>
                  <p className="section-subtitle">
                    Explore our latest articles on AI, educational technology, and learning innovations
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Featured Blog Section */}
        {featuredBlog && (
          <section className="featured-blog-section">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="featured-blog-card">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="featured-blog-image">
                          <img 
                            src={require(`../assets/img/blog/${featuredBlog.thumbnail}`)} 
                            alt={featuredBlog.title} 
                            className="img-fluid" 
                            width="400"
                            height="250"
                          />
                          <div className="featured-tag">Featured</div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="featured-blog-content">
                          <div className="blog-meta">
                            <span className="blog-category">{categories.find(c => c.id === featuredBlog.category)?.name}</span>
                            <span className="blog-date">{formatDate(featuredBlog.date)}</span>
                          </div>
                          <h2 className="featured-blog-title">{featuredBlog.title}</h2>
                          <p className="featured-blog-excerpt">{featuredBlog.excerpt}</p>
                          <div className="blog-author-info-left">
                            <span className="blog-author">By {featuredBlog.author}</span>
                            <span className="blog-read-time">{featuredBlog.readTime}</span>
                          </div>
                          <Link to={`/blog/${featuredBlog.id}`} className="btn-read-more">
                            Read Full Article
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* Blog Filter Section */}
        <section className="blog-filter-section">
          <div className="container">
            <div className="row">
              <div className="blog-categories">
                <ul className="category-list">
                  {categories.map(category => (
                    <li key={category.id}>
                      <button 
                        className={`category-btn ${selectedCategory === category.id ? 'active' : ''}`}
                        onClick={() => setSelectedCategory(category.id)}
                        aria-label={`Filter by ${category.name}`}
                      >
                        {category.name}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="blog-search">
                <input
                  type="text"
                  placeholder="Search articles..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="search-input"
                  aria-label="Search blog articles"
                />
                <button className="search-btn" aria-label="Search">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                    <path fillRule="evenodd" d="M10.5 3.75a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM2.25 10.5a8.25 8.25 0 1114.59 5.28l4.69 4.69a.75.75 0 11-1.06 1.06l-4.69-4.69A8.25 8.25 0 012.25 10.5z" clipRule="evenodd" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </section>

        <section className="blog-grid-section">
          <div className="container">
            {filteredBlogs.length > 0 ? (
              <div className="row">
                {filteredBlogs.map(blog => (
                  <div className="col-lg-4 col-md-6" key={blog.id}>
                    <div className="blog-card">
                      <div className="blog-card-image">
                        <img 
                          src={require(`../assets/img/blog/${blog.thumbnail}`)} 
                          alt={blog.title} 
                          className="img-fluid" 
                          width="300"
                          height="200"
                        />
                        <div className="blog-category-tag">
                          {categories.find(c => c.id === blog.category)?.name}
                        </div>
                      </div>
                      <div className="blog-card-content">
                        <div className="blog-meta">
                          <span className="blog-date">{formatDate(blog.date)}</span>
                          <span className="blog-read-time">{blog.readTime}</span>
                        </div>
                        <h3 className="blog-card-title">
                          <Link to={`/blog/${blog.id}`}>{blog.title}</Link>
                        </h3>
                        <p className="blog-card-excerpt">
                          {truncateText(blog.excerpt, 120)}
                        </p>
                        <div className="blog-card-footer">
                          <span className="blog-author">By {blog.author}</span>
                          <Link to={`/blog/${blog.id}`} className="read-more-link">
                            Read More
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                              <path fillRule="evenodd" d="M12.97 3.97a.75.75 0 011.06 0l7.5 7.5a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 11-1.06-1.06l6.22-6.22H3a.75.75 0 010-1.5h16.19l-6.22-6.22a.75.75 0 010-1.06z" clipRule="evenodd" />
                            </svg>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="row">
                <div className="col-12">
                  <div className="no-results">
                    <h3>No articles found</h3>
                    <p>Try adjusting your search or filter to find what you're looking for.</p>
                    <button 
                      className="reset-search-btn"
                      onClick={() => {
                        setSearchQuery("");
                        setSelectedCategory("all");
                      }}
                    >
                      Reset Search
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>


        <section className="newsletter-section">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="newsletter-card">
                  <div className="row align-items-center">
                    <div className="col-lg-6">
                      <div className="newsletter-content">
                        <h3 className="newsletter-title">Subscribe to Our Newsletter</h3>
                        <p className="newsletter-text">
                          Get the latest articles, updates, and insights on AI in education delivered right to your inbox.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="newsletter-form">
                        <form>
                          <div className="form-group">
                            <input
                              type="email"
                              placeholder="Enter your email address"
                              className="newsletter-input"
                              required
                            />
                            <button type="submit" className="newsletter-btn">
                              Subscribe
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      
      
      <OuterFooter />
    
    </div>
  );
};

export default Blogs; 